<template>
  <div id="index">
    <dv-full-screen-container class="bgImg">
      <dv-loading v-if="loading">Loading...</dv-loading>
      <div v-else class="host-body">
        <div class= 'topSpan'></div>
        <div>
            <div class="slogan">
              <span class = "slogan-text">Your first-ever MOVEMENT ROBOT for multiple scenarios in your daily life.</span>
            </div>
             <div class="opinion">
              <span class="opinion-text">We are coming soon!</span>
            </div>
        </div>

        <div class= 'logoSpan'>
          <span class="logoSpan-text">SUMBU</span>
        </div>

        <div class="bottom">
            <div class = "desc-div">
               <span class='desc'>Wanna live a boundless life or enjoy effortless excursions? Sumbu Robot is right for you.</span>
            </div>
            <div class = "desc-div">
              <span class='desc'>Enter your email to get further information. You may also be one of the first experiencers to try out this COOLEST new tech in 2025!</span>
            </div>
            <div class = "desc-div">
              <span class='desc'>Stay tuned!</span>  
            </div>
        </div>


        <div class="subForm">
             <div class="alertMsg" v-if="emailError" style="color:yellow;">{{ emailError}}</div>
             <form class="emailForm"  @submit.prevent="submitForm" >
                <label for="email" style="display:none;">Email</label>
                <input class="email"  v-model= "email" type="email" name="email"  placeholder="Enter your email" required />
                <input class="emailBtn" type="submit" @click="validateEmail" value="Get Connected"/>
              </form>
              <div class="promise-sec">
                <div id ="successMessage" class="successMessage"  style="color: green; display: none;">
                Thank you! We have received your email and will contact you soon.
                </div>
                <div id ="errorMessage" class="errorMessage"  style="color: red; display: none;">
                An error occurred. Please try again later.
                </div>
                <p class="promise" id="promise">We promise to never spam you :)</p>
              </div>
              
          </div>

      </div>
    </dv-full-screen-container>
  </div>
</template>

<script>
import axios from 'axios';

export default {
  data() {
    return {
      loading: true,
      email: '',
      emailError: ''
    };

  },

  components: {

  },

  mounted() {
    this.cancelLoading();
  },

  methods: {
    cancelLoading() {
      setTimeout(() => {
        this.loading = false;
      }, 2000);
    },

    validateEmail() {
      if (!this.isValidEmail(this.email)) {
        this.emailError = 'Please enter a valid email address！';
      } else {
        this.emailError = '';
      }
    },

    isValidEmail(email) {
      const regex = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
      return regex.test(email);
    },

    async submitForm (){
       try {
          
          const response = await axios.post('https://www.sumbu.tech/sumbu/login/collectEmail', {
            email: this.email
          });
          
          var successMessage = document.getElementById('successMessage');
          var errorMessage = document.getElementById('errorMessage');
          var promiseMessage = document.getElementById('promise');
          console.log(response.data);

          if(response.data.code == 200){
            successMessage.style.display = 'block'; // 显示成功消息
            promiseMessage.style.display = 'none'; 
            errorMessage.style.display = 'none'; // 显示失败消息
            
          }else{
            errorMessage.style.display = 'block'; // 显示失败消息
            successMessage.style.display = 'none'; // 显示成功消息
            promiseMessage.style.display = 'none'; 
          }
          this.email = "";
          
        } catch (error) {
          console.error('There was an error!', error);
          errorMessage.style.display = 'block'; // 显示失败消息
          promiseMessage.style.display = 'none'; 
          successMessage.style.display = 'none'; // 显示成功消息
          this.email = "";
        }
    }
  }


  
};
</script>

<style lang="scss" scoped>
@import "../assets/scss/index.scss";
@import "../assets/scss/font.scss";
</style>